import { render } from "./Footer.vue?vue&type=template&id=0a3ac954&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=0a3ac954&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3ac954"]])

export default __exports__